module.exports = __webpack_public_path__ + "img/c1.d808e52c.png";